import React from "react";
import { Button } from "flowbite-react";

type LinkProps = {
  href: string;
  children: React.ReactNode;
  className?: string;
  targetBlank?: boolean;
};

export const Link: React.FC<LinkProps> = ({
  href,
  children,
  className,
  targetBlank,
}) => {
  return (
    <a
      href={href}
      className={`underline text-primary-600 hover:text-primary-700 active:text-secondary-500 transition-colors duration-200 ${className}`}
      target={targetBlank ? "_blank" : undefined}
    >
      {children}
    </a>
  );
};

export const LinkButton: React.FC<LinkProps> = ({
  href,
  children,
  className,
  targetBlank,
}) => {
  return (
    <a href={href} target={targetBlank ? "_blank" : undefined}>
      <Button
        outline
        className={`h-auto min-h-10 border-2 border-primary-500 bg-white py-2 text-gray-900 hover:border-primary-500 hover:bg-primary-500 hover:text-white ${className}`}
      >
        {children}
      </Button>
    </a>
  );
};
